export default "__VITE_ASSET__Ao$MM6WR__"